<template>
  <div class="product-container">
    <p class="notification-subtitle paddingBottom no-margin">Enter a phone number</p>
    <VTextField
      v-model="number"
      type="tel"
      aria-label="Enter Phone Number"
      :maxlength="15"
      placeholder="+1239876543210"
      appearance="ghost"
      class="vivid-input"
      @blur="onInput"
    ></VTextField>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{
  modelValue: string | undefined
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string | undefined]
}>();

const number = ref<string | undefined>(props.modelValue);

watch(() => props.modelValue, (val) => {
  number.value = val;
});

function onInput() {
  emit('update:modelValue', number.value || undefined);
}
</script>

<style scoped>
.product-container {
  margin-top: 20px;
  margin-bottom: 20px;
}
.paddingBottom {
  padding-bottom: 10px;
}
.no-margin {
  margin: 0;
}
</style>
